import { SVGProps, Ref, forwardRef } from 'react';

export const EnvelopeFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M.77 3.656C.226 4.49 0 5.686 0 7.332v1.333c0 3.999 1.333 5.332 5.332 5.332h5.332c3.999 0 5.332-1.333 5.332-5.332V7.332c0-1.646-.226-2.84-.77-3.676L7.998 9.569z"
                fill="currentColor"
            />
            <path
                d="M1.794 2.685 7.998 7.76l6.203-5.075C13.375 2.202 12.221 2 10.665 2H5.332c-1.557 0-2.71.202-3.538.685"
                fill="currentColor"
            />
        </g>
    </svg>
));
EnvelopeFilledSize16Glyph.displayName = 'EnvelopeFilledSize16Glyph';
